import { render, staticRenderFns } from "./PortalFieldValues.vue?vue&type=template&id=36a9f552&"
import script from "./PortalFieldValues.vue?vue&type=script&lang=js&"
export * from "./PortalFieldValues.vue?vue&type=script&lang=js&"
import style0 from "./PortalFieldValues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports